import { render, staticRenderFns } from "./numbered_mode.vue?vue&type=template&id=7050384a&scoped=true"
import script from "./numbered_mode.vue?vue&type=script&lang=js"
export * from "./numbered_mode.vue?vue&type=script&lang=js"
import style0 from "./numbered_mode.vue?vue&type=style&index=0&id=7050384a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7050384a",
  null
  
)

export default component.exports